<div class="mobile-cards">
    <ng-container *ngIf="data.length > 0">
        <div class="card" *ngFor="let row of data">
            <!-- Header Section -->
            <div class="card-header">
                <h2>
                    {{ row.title }}
                    <i *ngIf="row.description" class="pi pi-info-circle info-icon" pTooltip="{{ row.description }}"
                        tooltipPosition="top" appendTo="body" [tooltipEvent]="'focus'" tabindex="0"></i>
                </h2>
                <p *ngIf="row.subtitle" class="card-subtitle">{{ row.subtitle }}</p>
            </div>

            <!-- Financial Section -->
            <div class="card-details">
                <div class="detail-item" *ngFor="let detailItem of row.details">
                    <strong>{{detailItem.title}}:</strong>
                    <span *ngIf="detailItem.openLink == null"[innerHTML]="detailItem.value"></span>
                    <div *ngIf="detailItem.openLink">
                        <div class="star-tag txt-blue w-i mr-2" style="max-width: 70px;" *ngIf="detailItem.openLink=='comments'">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" rx="10" fill="#095A70" />
                            <path
                                d="M8.09383 9.79434V15H6V6.11568H8.00129V7.62532H8.1054C8.30977 7.12789 8.6356 6.73265 9.08291 6.43959C9.53406 6.14653 10.0913 6 10.7545 6C11.3676 6 11.9017 6.13111 12.3567 6.39332C12.8156 6.65553 13.1703 7.03535 13.421 7.53278C13.6754 8.03021 13.8008 8.63368 13.7969 9.34319V15H11.7031V9.66709C11.7031 9.07326 11.5488 8.60861 11.2404 8.27314C10.9357 7.93766 10.5135 7.76992 9.97365 7.76992C9.60733 7.76992 9.28149 7.8509 8.99614 8.01285C8.71465 8.17095 8.49293 8.40039 8.33098 8.70116C8.17288 9.00193 8.09383 9.36632 8.09383 9.79434Z"
                                fill="white"
                            />
                            </svg>
                    
                            <span class="ml-2 star-value f-14" *ngIf="row.workflow">
                            {{row.companyWorkflowCommentsLength ?? 0}}
                            </span>
                            <span class="ml-2 star-value f-14" *ngIf="row.workflow==null">
                            0
                            </span>
                        </div>
                        <div *ngIf="detailItem.openLink=='stats'">
                            <bpc-voting-column [row]="row"/>                        
                        </div>
                        <div *ngIf="detailItem.openLink=='summary'">
                            <bpc-summary-column [row]="row"/>
                        </div>
                        <div *ngIf="detailItem.openLink=='editUser'">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Section -->
            <div class="card-footer" *ngIf="row.route">
                <a class="company-link" [routerLink]="['/m' + row.route]">View Details</a>
            </div>
        </div>
    </ng-container>

    <div *ngIf="loading" class="card">
        <bpc-dynamic-skeleton-loader [numberOfSkeletons]="10" />
    </div>

     <!-- No Records Card -->
     <div *ngIf="!loading && data.length === 0" class="card no-record-card">
        <div class="card-header">
            <h2>No Records Found</h2>
        </div>
        <div class="card-details">
            <p>There are currently no records to display. Please check back later or refine your filters.</p>
        </div>
    </div>
</div>
